<script setup lang="ts">
import {ref} from 'vue';
import {TextInput, useClose} from '@hantera/design-system'
import useBackend from "@/composition/useBackend";
import {PhraseTemplate} from "@/backend/phrases";

const props = defineProps<{
  phrase: PhraseTemplate
}>();

const value = ref('');
const { phrases } = useBackend();
const close = useClose();
const input = ref();

function save() {
  
  value.value = value.value.trim().toLowerCase();
  
  if (value.value.length !== 2) {
    input.value.setError('Must be 2 letters');
    return;
  }
  
  if (Object.keys(props.phrase.translations).indexOf(value.value) >= 0) {
    input.value.setError('Already exists');
    return;
  }
  
  props.phrase.translations[value.value] = ''
  
  close();
}

</script>

<template>
  <form class="new-language" @submit.prevent="save">
    <div>
      <TextInput v-model="value" ref="input" class="new-language__input" />
    </div>
    <input type="submit" class="btn-primary" value="OK" />
  </form>
</template>

<style>

.new-language {
  display: flex;
  padding-top: 5px;
  align-items: flex-start;
  gap: 5px;
  
  
}

.new-language__input {
  text-transform: uppercase;
}

</style>